import { render, staticRenderFns } from "./LandingPageWhyChooseComponent.vue?vue&type=template&id=50a6dd54&scoped=true&"
import script from "./LandingPageWhyChooseComponent.vue?vue&type=script&lang=js&"
export * from "./LandingPageWhyChooseComponent.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageWhyChooseComponent.vue?vue&type=style&index=0&id=50a6dd54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a6dd54",
  null
  
)

export default component.exports